const styles = theme => ({
    wrapper: {
        marginBottom: theme.spacing(1)
    },
    dialogRoot: {
        minWidth: 350
    },
    dialogOpen: {
        overflow: 'hidden'
    },
    appBar: {
    },
    flex: {
        flex: 1
    },
    grow: {
        flexGrow: 1
    },
    panel: {
        overflow: 'auto'
    },
    buttonPanel: {
        justifyContent: 'flex-end',
        display: 'flex'
    },
    button: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)

    }
});

export default styles;